import React from 'react'

const Card_3 = (props) => {
    const {icon, title, subTitle} = props;
    return (
        <div className="sec-3-feature-box has_fade_anim h-100" style={{ transform: 'translate(0px, 0px)', opacity: 1 }}>
            <div className="thumb">
                <img src={icon} alt="Manage icon" />
            </div>
            <div className="content mt-5">
                <h3 className="title text-grad-3 fs-1">
                   {title}
                </h3>
                <p className="text mt-5 fs-3 text-gray-900">
                    {subTitle}
                </p>
                <span className="wc-btn wc-btn-normal fs-4">
                    Read more<i className="fa-solid fa-arrow-right text-gray-800"></i>
                </span>
            </div>
        </div>
    )
}

export {Card_3}